import axiosInstance from '../utils/axiosInstance';

const getDataResult = (response) => response.data?.data ?? response.data ?? {};

export const fetchPanicIncidents = async (params = {}) => {
  const response = await axiosInstance.get('/panic/incidents', { params });
  return {
    data: getDataResult(response) || [],
    pagination: response.data?.pagination || {},
  };
};

export const fetchPanicIncident = async (id) => {
  const response = await axiosInstance.get(`/panic/incidents/${id}`);
  return getDataResult(response);
};

export const acceptPanicIncident = async (id) => {
  const response = await axiosInstance.post(`/panic/incidents/${id}/accept`);
  return {
    incident: getDataResult(response),
    talk: response.data?.talk || null,
  };
};

export const startPanicTalk = async (id) => {
  const response = await axiosInstance.post(`/panic/incidents/${id}/talk/start`);
  return response.data?.talk || null;
};

export const endPanicTalk = async (id) => {
  const response = await axiosInstance.post(`/panic/incidents/${id}/talk/end`);
  return getDataResult(response);
};

export const touchPanicPresence = async (id) => {
  await axiosInstance.post(`/panic/incidents/${id}/presence`);
};

export const closePanicIncident = async (id, resolution) => {
  const response = await axiosInstance.post(`/panic/incidents/${id}/close`, { resolution });
  return getDataResult(response);
};

export const getPanicSnapshotUrl = (id) => {
  const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const token = localStorage.getItem('authToken') || '';
  const params = token ? `?token=${encodeURIComponent(token)}` : '';
  return `${apiBase}/panic/incidents/${id}/snapshot${params}`;
};

export const fetchPanicSnapshotBlob = async (id) => {
  const response = await axiosInstance.get(`/panic/incidents/${id}/snapshot`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};
